import { OIEntity, OIScaleRange, TraceLense, TraceStrikeBarType } from './oi';

export interface TraceColorsConfig {
  posColor?: string;
  negColor?: string;
  posStrikeColor?: string;
  negStrikeColor?: string;
  putColor?: string;
  callColor?: string;
  upCandleFill?: string;
  downCandleFill?: string;
  upCandleLineColor?: string;
  downCandleLineColor?: string;
  hiroColor?: string;
  contourLineColor?: string;
  customColorsPerLense?: Partial<
    Record<TraceLense, { posHeatmapColor?: string; negHeatmapColor?: string }>
  >;
}

export interface TraceConfig extends TraceColorsConfig {
  // Navigation
  sym: string;
  date: string;
  timestamp?: string;
  lense: TraceLense;

  // Market actor / inversion
  mktActor: OIEntity;
  inverted: boolean;
  filterLinesBasedOnTimeSlider: boolean;

  // Strike bars
  strikeBarType: TraceStrikeBarType;
  strikeZoom: number;
  strikeBarsTrackerEnabled: boolean;
  strikeBarsHistoryEnabled: boolean;
  showGexZeroDte: boolean;

  // Heatmap display
  priceZoom: number;
  candleDuration: number;
  scaleRange: OIScaleRange;
  showKeyLevels: boolean;
  showColorScale: boolean;
  showContourLines: boolean;
  useWhiteMode: boolean;

  // HIRO
  hiroSyms: Record<string, string>;

  // Stats
  statsLookbackDays: number;
}

export const DEFAULT_TRACE_SYM = 'SPX';
export const DEFAULT_CANDLE_DURATION_SECONDS = 5 * 60;
export const DEFAULT_STATS_LOOKBACK_DAYS = 30;
